import { render, staticRenderFns } from "./rewardRankEdit_bak.vue?vue&type=template&id=653c57a9&scoped=true&"
import script from "./rewardRankEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardRankEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c57a9",
  null
  
)

export default component.exports